import { useAuth } from 'contexts/auth';
import useExperiment from 'hooks/common/use-experiment';

interface UseTest8629Return {
  /** Whether Savings Plan should be shown based on A/B test (test group OR has active SP) */
  showSavingsPlanTest: boolean;
  /** Loading state of the experiment */
  loading: boolean;
  /** The variant number (0 = control, 1 = test) */
  variant: number | undefined;
}

/**
 * Hook for A/B Test: Savings Plan visibility
 * Control group (variant 0): No Savings Plan visible anywhere
 * Test group (variant 1): Savings Plan available as current implementation
 * Users with existing active SP are always shown SP functionality
 * @see https://petsdeli.atlassian.net/browse/PT-8629
 */
const useTest8629 = (): UseTest8629Return => {
  const { variant, loading } = useExperiment({
    baseEntryId: '5Etez8wH4Nq3i5TOZsfNpY',
  });

  const { customer } = useAuth();
  const hasActiveSavingsPlan = !!customer?.savingsPlan;

  // Users with active SP should always see SP, regardless of variant assignment
  const showSavingsPlanTest = variant === 1 || hasActiveSavingsPlan;

  return {
    showSavingsPlanTest,
    loading,
    variant,
  };
};

export default useTest8629;
